



























import { Vue, Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";
import { BrandConfigKeys } from "@/data/constants";
import { IClient } from "@/models/clients";
import { UUID } from "@/data/enums";
import { IBrand } from "@/models/brands";
import i18n from "@/i18n";

@Component({
  components: {
    "client-search": () =>
      import("@/components/app/global/client/clientSearch.vue")
  },
  computed: {
    ...mapState({
      isMultibrand: (state, getters) => {
        return getters["brand/isMultibrand"];
      }
    })
  }
})
export default class SelectClientModal extends Vue {
  // Props

  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];

  @Prop({ default: false })
  public allowGuestClientOption!: boolean;

  @Prop({ default: () => i18n.t("_action.select_client") })
  public readonly title!: string;

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: Record<string, any>;

  @Prop({ default: true })
  public showGuestsToggle!: boolean;

  @Prop({ default: "" })
  public withParams!: string;

  // Data

  public isProcessing = false;
  public isMultibrand!: boolean;
  public canCheckoutAsGuest = false;

  // Lifecycle methods

  public async created() {
    if (this.isMultibrand || !this.allowGuestClientOption) return;
    const config = await this.$store.dispatch("brand/getConfig", {
      keys: [BrandConfigKeys.GUEST_CHECKOUT_ENABLED],
      ignoreStored: true,
      brandId: this.$store.state.auth.admin.brandId
    });
    this.canCheckoutAsGuest = !!config[BrandConfigKeys.GUEST_CHECKOUT_ENABLED];
  }

  // Methods

  public onClientSelect(client: IClient) {
    this.$emit("onSelect", client);
    this.$emit("close");
  }

  public async continueAsGuest() {
    if (!this.canCheckoutAsGuest) return;
    this.isProcessing = true;
    try {
      // Create new guest client
      const client: IClient = await this.$store.dispatch(
        `data/${DataModules.CLIENTS}/createGuestClient`
      );
      this.$emit("onSelect", client);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
    this.isProcessing = false;
  }
}
